module.exports = __webpack_public_path__ + "img/planned.bbb63ff9.svg";